module.exports = __webpack_public_path__ + "static/mtb-14-8a9f58f60860f434b9337448ad82020f.jpg";